import React, { useEffect, useState } from 'react';
import styles from './UsersTab.module.scss';

import { getAllUsers, updateUserRole } from '../../../utils/api/usersAPI'; 
import { getAllGames } from '../../../utils/api/gamesAPI';
import { assignGameToUser, getGamesByUser, revokeGameFromUser } from '../../../utils/api/partenairesAPI';


const UsersTab = () => {
  const token = localStorage.getItem('token');

  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isPartner, setIsPartner] = useState(false);
  const [availableGames, setAvailableGames] = useState([]);
  const [selectedGameId, setSelectedGameId] = useState(null);
  const [assignedGames, setAssignedGames] = useState([]);


  useEffect(() => {
  const fetchGames = async () => {
    try {
      const data = await getAllGames();
      setAvailableGames(data); // supposé tableau de jeux [{id, name}]
    } catch (err) {
      console.error('Erreur lors du chargement des jeux', err);
    }
  };
  fetchGames();
}, []);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const data = await getAllUsers({ token, q: query, page, limit });
        setUsers(data.users);
        setTotal(data.total);
      } catch (err) {
        setError('Erreur de chargement des utilisateurs');
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [query, page, limit, token]);


  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setPage(1);
  };


  const handleViewUser = async (user) => {
    setSelectedUser(user);
    console.log('[DEBUG] role reçu:', user.role);
    setIsPartner(user.role.toUpperCase() === 'PARTNER');
    
    try {
      const links = await getGamesByUser(user.id);
      const mapped = links
        .map(link => availableGames.find(game => game.id === link.id_game))
        .filter(Boolean); // enlève les jeux non trouvés

      setAssignedGames(mapped);
    } catch (err) {
      console.error('Erreur chargement des jeux attribués', err);
      setAssignedGames([]);
    }
  };


  const handleTogglePartner = async () => {
    const newValue = !isPartner;
    const newRole = newValue ? 'PARTNER' : 'USER';

    try {
      await updateUserRole(selectedUser.id, newRole);
      setIsPartner(newValue);
      setSelectedUser((prevUser) => ({
        ...prevUser,
        role: newRole.toLowerCase(),
      }));

      // Optionnel : message visuel ou toast
      // alert(`Le rôle a été mis à jour vers ${newRole}`);
    } catch (err) {
      console.error('Erreur lors de la mise à jour du rôle', err);
      alert('Échec de la mise à jour du rôle');
    }
  };


  const handleRevokeGame = async (gameId) => {
    const confirm = window.confirm('Révoquer ce jeu de cet utilisateur ?');
    if (!confirm) return;

    try {
      await revokeGameFromUser(selectedUser.id, gameId);
      setAssignedGames((prev) => prev.filter((game) => game.id !== gameId));
    } catch (err) {
      console.error('Erreur lors de la révocation du jeu', err);
      alert('Échec de la révocation');
    }
  };


  const totalPages = Math.ceil(total / limit);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Administration des utilisateurs</h2>

      <input
        type="text"
        placeholder="Rechercher par pseudo ou email"
        value={query}
        onChange={handleSearchChange}
        className={styles.searchInput}
      />

      {loading ? (
        <p>Chargement...</p>
      ) : error ? (
        <p className={styles.error}>{error}</p>
      ) : (
        <>
          <div className={styles.tableWrapper}>
            <table className={styles.userTable}>
              <colgroup>
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  {/* <th>ID</th> */}
                  <th>Pseudo</th>
                  <th>Email</th>
                  <th>Rôle</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    {/* <td>{user.id}</td> */}
                    <td>{user.pseudo}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>
                      <button onClick={() => handleViewUser(user)}>Voir</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className={styles.pagination}>
            <button onClick={() => setPage((p) => Math.max(p - 1, 1))} disabled={page === 1}>
              Précédent
            </button>
            <span>Page {page} / {totalPages}</span>
            <button onClick={() => setPage((p) => Math.min(p + 1, totalPages))} disabled={page === totalPages}>
              Suivant
            </button>
          </div>
        </>
      )}

      {selectedUser && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <h3 className={styles.title}>Détails de l'utilisateur</h3>
            {/* <p><strong>ID:</strong> {selectedUser.id}</p> */}
            <p><strong>Pseudo:</strong> {selectedUser.pseudo}</p>
            <p><strong>Email:</strong> {selectedUser.email}</p>
            <p><strong>Rôle:</strong> {selectedUser.role}</p>

            <div>
              {/* <label>
                <input
                  className={styles.switch}
                  type="checkbox"
                  checked={isPartner}
                  onChange={handleTogglePartner}
                  // onChange={(e) => setIsPartner(e.target.checked)}
                />{' '}
                Compte partenaire
              </label> */}
              <label>
                <label className={styles.switch}>
                  <input type="checkbox" checked={isPartner}
                      onChange={handleTogglePartner}
                  />
                  <span className={styles.slider}></span>
                </label>
                <span className={styles.switchLabel}>Transformer en compte partenaire</span>
              </label>
            </div>

            {isPartner && (
              <div className={styles.partnerSection}>
                <h4>Jeux attribuables</h4>
                <select
                  value={selectedGameId || ''}
                  onChange={(e) => setSelectedGameId(parseInt(e.target.value))}
                >
                  <option value="" disabled>-- Sélectionner un jeu --</option>
                  {availableGames.map((game) => (
                    <option key={game.id} value={game.id}>{game.nom}</option>
                  ))}
                </select>

                <button
                  disabled={!selectedGameId}
                  onClick={async () => {
                    try {
                      await assignGameToUser(selectedUser.id, selectedGameId);
                      setAssignedGames((prev) => [
                        ...prev,
                        availableGames.find((g) => g.id === selectedGameId),
                      ]);
                      setSelectedGameId(null);
                    } catch (err) {
                      alert('Erreur lors de l\'attribution du jeu');
                    }
                  }}
                >
                  Attribuer le jeu
                </button>

                <h4>Jeux attribués</h4>
                <ul>
                  {assignedGames.map((game) => (
                    <li key={game.id}>
                      {game.nom}{' '}
                      <button onClick={() => handleRevokeGame(game.id)}>Révoquer</button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <button onClick={() => setSelectedUser(null)}>Fermer</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersTab;
